
<div class="outer">
  <div class="inner">


    <h2 class="">
      {{prompt}}
    </h2>

    <p [innerHTML]="paragraph"></p>

    <div class="input-group">
      <input id="fullname" name="name" type="text" class="form-control" aria-label="Please enter your full name" placeholder="Type here" #name (keydown)="onType($event)">

      @if (invalid) {
        <span class="input-group-addon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fill-rule="evenodd">
              <path d="M0 0h24v24H0z" />
              <path fill="#FF495C" d="M12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586 9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
                />
            </g>
          </svg>
        </span>
      }

    </div>


    <div class="error-container">
      <span>{{helper}}</span>
    </div>


    <button data-testid="fullname-next" (click)="next()" class="btn btn-outline-primary btn-outline hover active">Next</button>


  </div>
